import { createStore } from "owa-satcheljs";
import type { MailFolder } from "owa-graph-schema";

export interface PublicFolderStore {
    folderTable: Map<string, MailFolder>; // where we store the loaded folders
    rootFolder: MailFolder | null; // root folder corresponding to IPM_SUBTREE
}

const initialState: PublicFolderStore = {
    folderTable: new Map<string, MailFolder>(),
    rootFolder: null,
};

const publicFolderFavoriteStore: () => PublicFolderStore = createStore<PublicFolderStore>("publicFolderFavoriteStore", initialState);

export default publicFolderFavoriteStore;
